import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { useSuperAdmin } from "@/hooks/useSuperAdmin";

interface SuperAdminRouteProps {
  children: React.ReactNode;
}

const SuperAdminRoute = ({ children }: SuperAdminRouteProps) => {
  const { user, isLoading: authLoading } = useAuth();
  const { isSuperAdmin, isLoading: superAdminLoading } = useSuperAdmin();
  const navigate = useNavigate();

  const isLoading = authLoading || superAdminLoading;

  useEffect(() => {
    // Only proceed if BOTH auth and super admin checks are completely done
    if (authLoading || superAdminLoading) {
      return;
    }
    
    if (!user) {
      navigate('/auth');
    } else if (!isSuperAdmin) {
      navigate('/dashboard');
    }
  }, [user, isSuperAdmin, authLoading, superAdminLoading, navigate]);

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!user || !isSuperAdmin) {
    return null;
  }

  return <>{children}</>;
};

export default SuperAdminRoute;
